import React from 'react';
import PropTypes from 'prop-types';

const CloseIcon = ({ width, height }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 1024 1024"
  >
    <path d="M573.138 513.993l393.412-396.072q34.559-29.24 0-58.479-29.24-34.559-58.479 0l-396.072 393.412-396.072-393.412q-29.24-34.559-58.479 0-34.559 29.24 0 58.479l393.412 396.072-393.412 396.072q-34.559 29.24 0 58.479 13.293 13.293 29.24 13.293t29.24-13.293l396.072-393.412 396.072 393.412q13.293 13.293 29.24 13.293t29.24-13.293q34.559-29.24 0-58.479z" />
  </svg>
);

CloseIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

CloseIcon.defaultProps = {
  width: 16,
  height: 16,
};

export default CloseIcon;
